"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CategorySmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M5,10 L8,10 C8.55228475,10 9,10.4477153 9,11 L9,14 C9,14.5522847 8.55228475,15 8,15 L5,15 C4.44771525,15 4,14.5522847 4,14 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M5,11 L5,14 L8,14 L8,11 L5,11 Z M12.5,15 C11.1192881,15 10,13.8807119 10,12.5 C10,11.1192881 11.1192881,10 12.5,10 C13.8807119,10 15,11.1192881 15,12.5 C15,13.8807119 13.8807119,15 12.5,15 Z M12.5,14 C13.3284271,14 14,13.3284271 14,12.5 C14,11.6715729 13.3284271,11 12.5,11 C11.6715729,11 11,11.6715729 11,12.5 C11,13.3284271 11.6715729,14 12.5,14 Z M9.92874646,3.24275212 L12.9287465,8.24275212 C13.0708205,8.47954226 12.994038,8.78667238 12.7572479,8.92874646 C12.6795402,8.97537108 12.590622,9 12.5,9 L6.5,9 C6.22385763,9 6,8.77614237 6,8.5 C6,8.40937803 6.02462892,8.32045982 6.07125354,8.24275212 L9.07125354,3.24275212 C9.21332762,3.00596199 9.52045774,2.92917946 9.75724788,3.07125354 C9.82762268,3.11347842 9.88652158,3.17237732 9.92874646,3.24275212 Z M7.38309519,8 L11.6169048,8 L9.5,4.47182532 L7.38309519,8 Z" })));
};
CategorySmall.displayName = 'CategorySmall';
exports.default = CategorySmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CategorySmall.js.map